module.exports = __webpack_public_path__ + "static/media/newline1.4e6d49a2.jpg";